/*
 * CSS debug and reset
 */

// Makes every element different colored outline
export const debug = `body{outline:#2980b9 solid 1px!important}article{outline:#3498db solid 1px!important}nav{outline:#0088c3 solid 1px!important}aside{outline:#33a0ce solid 1px!important}section{outline:#66b8da solid 1px!important}header{outline:#99cfe7 solid 1px!important}footer{outline:#cce7f3 solid 1px!important}h1{outline:#162544 solid 1px!important}h2{outline:#314e6e solid 1px!important}h3{outline:#3e5e85 solid 1px!important}h4{outline:#449baf solid 1px!important}h5{outline:#c7d1cb solid 1px!important}h6{outline:#4371d0 solid 1px!important}main{outline:#2f4f90 solid 1px!important}address{outline:#1a2c51 solid 1px!important}div{outline:#036cdb solid 1px!important}p{outline:#ac050b solid 1px!important}hr{outline:#ff063f solid 1px!important}pre{outline:#850440 solid 1px!important}blockquote{outline:#f1b8e7 solid 1px!important}ol{outline:#ff050c solid 1px!important}li,ul{outline:#d90416 solid 1px!important}dl{outline:#fd3427 solid 1px!important}dt{outline:#ff0043 solid 1px!important}dd{outline:#e80174 solid 1px!important}figure{outline:#f0b solid 1px!important}figcaption{outline:#bf0032 solid 1px!important}object,table{outline:#0c9 solid 1px!important}caption,param{outline:#37ffc4 solid 1px!important}embed,thead{outline:#98daca solid 1px!important}iframe,tbody{outline:#64a7a0 solid 1px!important}img,tfoot{outline:#22746b solid 1px!important}tr{outline:#86c0b2 solid 1px!important}th{outline:#a1e7d6 solid 1px!important}td{outline:#3f5a54 solid 1px!important}col{outline:#6c9a8f solid 1px!important}colgroup{outline:#6c9a9d solid 1px!important}button{outline:#da8301 solid 1px!important}datalist{outline:#c06000 solid 1px!important}fieldset{outline:#d95100 solid 1px!important}form{outline:#d23600 solid 1px!important}input{outline:#fca600 solid 1px!important}keygen{outline:#b31e00 solid 1px!important}label{outline:#ee8900 solid 1px!important}legend{outline:#de6d00 solid 1px!important}meter{outline:#e8630c solid 1px!important}optgroup{outline:#b33600 solid 1px!important}option{outline:#ff8a00 solid 1px!important}output{outline:#ff9619 solid 1px!important}progress{outline:#e57c00 solid 1px!important}select{outline:#e26e0f solid 1px!important}textarea{outline:#cc5400 solid 1px!important}details{outline:#33848f solid 1px!important}summary{outline:#60a1a6 solid 1px!important}command{outline:#438da1 solid 1px!important}menu{outline:#449da6 solid 1px!important}del{outline:#bf0000 solid 1px!important}ins{outline:#400000 solid 1px!important}video{outline:#6ee866 solid 1px!important}audio{outline:#027353 solid 1px!important}source{outline:#012426 solid 1px!important}canvas{outline:#a2f570 solid 1px!important}track{outline:#59a600 solid 1px!important}map{outline:#7be500 solid 1px!important}area{outline:#305900 solid 1px!important}a{outline:#ff62ab solid 1px!important}em{outline:#800b41 solid 1px!important}strong{outline:#ff1583 solid 1px!important}i{outline:#803156 solid 1px!important}b{outline:#cc1169 solid 1px!important}u{outline:#ff0430 solid 1px!important}s{outline:#f805e3 solid 1px!important}small{outline:#d107b2 solid 1px!important}abbr{outline:#4a0263 solid 1px!important}q{outline:#240018 solid 1px!important}cite{outline:#64003c solid 1px!important}dfn{outline:#b4005a solid 1px!important}sub{outline:#dba0c8 solid 1px!important}sup{outline:#cc0256 solid 1px!important}time{outline:#d6606d solid 1px!important}code{outline:#e04251 solid 1px!important}kbd{outline:#5e001f solid 1px!important}samp{outline:#9c0033 solid 1px!important}var{outline:#d90047 solid 1px!important}mark{outline:#ff0053 solid 1px!important}bdi{outline:#bf3668 solid 1px!important}bdo{outline:#6f1400 solid 1px!important}ruby{outline:#ff7b93 solid 1px!important}rt{outline:#ff2f54 solid 1px!important}rp{outline:#803e49 solid 1px!important}span{outline:#cc2643 solid 1px!important}br{outline:#db687d solid 1px!important}wbr{outline:#db175b solid 1px!important}`;
// Reset
export const reset = (extend = '', useFixedHeight = true): string => `
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed,
  figure, figcaption, footer, header, hgroup,
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video, input, textarea, button, select  {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    vertical-align: baseline;
    box-sizing: border-box;
  }
  *:focus {
    outline: none;
  }
  /* HTML5 display-role reset for older browsers */
  article, aside, details, figcaption, figure,
  footer, header, hgroup, menu, nav, section {
    display: block;
  }
  body {
    line-height: 1;
  }
  blockquote, q {
    quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }
  html, body {
    ${useFixedHeight ? 'height: 100%;' : 'min-height: 100%;'}
    width: 100%;
    -ms-overflow-style: -ms-autohiding-scrollbar;
  }
  ${extend}
`;

// For non-overflowing web-apps, use fixed height while for websites, use the min-height.
export const setup = (selector: string, useFixedHeight = true): string => `
${selector} {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-flex: 1;
      -ms-flex: 1 1 auto;
          flex: 1 1 auto;
  ${useFixedHeight ? 'height: 100%;' : 'min-height: 100%;'}
  width: 100%;
}
 `;
